import { CommonState } from 'common/types/commonState'
import { EditorContent } from 'common/types/entities/news'
import { fetchStoreBrandNews } from 'common/services/channel'
import { StateKey } from 'common/utils/flipState'
import { createCacheParam, isCacheHit } from 'common/utils/reduxCache'

const initialState: EditorContent = {
  contentId: null,
  editorType: null,
  textContent: null,
  renderContent: null,
  mobileRenderContent: null,
  cacheParam: null,
}

const FETCH = 'store/brandNews/FETCH'

export const fetchBrandNews = (curState: StateKey, storeId: string) => async (
  dispatch,
  getState: () => CommonState,
) => {
  const cacheParam = createCacheParam(FETCH, 'fetchBrandNews', { curState, storeId })
  if (isCacheHit(getState().brandNews[curState], cacheParam)) {
    return
  }

  const brand = await fetchStoreBrandNews(storeId)
  dispatch({
    curState,
    cacheParam,
    type: FETCH,
    payload: brand,
  })
}

const brandNewsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
      return {
        ...action.payload,
        cacheParam: action.cacheParam,
      }
    default:
      return state
  }
}

export default brandNewsReducer
